var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgThird = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M20.572 12c0 4.714-3.858 8.572-8.572 8.572S3.43 16.714 3.43 12 7.286 3.43 12 3.43 20.572 7.286 20.572 12m1.714 0c0 5.657-4.629 10.286-10.286 10.286S1.714 17.657 1.714 12 6.343 1.714 12 1.714 22.286 6.343 22.286 12",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 11.424a1 1 0 0 0 .498.865l4.554 2.64c.476.276 1.094.116 1.302-.395A6.8 6.8 0 0 0 18.857 12c0-3.433-2.557-6.298-5.86-6.784-.547-.08-.997.375-.997.927z",
  clipRule: "evenodd"
})));
export default SvgThird;